import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$root/types/components/partials/modules.d.ts').TextBlock}
 */
const Text = ({
    heading,
    text
}) => {
    return (
        <div className='text-block'>
            {heading && (
                <p className='pb-12'>
                    {heading}
                </p>
            )}
            {text && (
                <div
                    className='rich-text'
                    dangerouslySetInnerHTML={{ __html: text}}/>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Text;
